module.exports = __webpack_public_path__ + "img/Recurso 10.8d893128.png";